import { UserSettings } from '../../environmentVariables/EnvironmentVariables';

export function getSanitizedUserSettingsForPosthog(
	settings: UserSettings
): Record<string, unknown> {
	return {
		// RPC (label only, not the URL)
		settings_rpcEndpointLabel: settings.rpcEndpoint?.label,

		// Feature toggles
		settings_enableVersionedTx: settings.enableVersionedTx,
		settings_enableSwapLeverage: settings.enableSwapLeverage,
		settings_placeAndTakeEnabled: settings.placeAndTakeEnabled,
		settings_directRouteSwaps: settings.directRouteSwaps,
		settings_swiftEnabled: settings.swiftEnabled,
		settings_oracleOffsetOrdersEnabled: settings.oracleOffsetOrdersEnabled,

		// UI preferences
		settings_showPnlOnClose: settings.showPnlOnClose,
		settings_showTradeConfirmation: settings.showTradeConfirmation,
		settings_showClosePositionConfirmation:
			settings.showClosePositionConfirmation,
		settings_showAccountValues: settings.showAccountValues,
		settings_showFillNotifications: settings.showFillNotifications,
		settings_showZeroValues: settings.showZeroValues,
		settings_blinkOnValueChange: settings.blinkOnValueChange,
		settings_showPositionsAndOrdersOnChart:
			settings.showPositionsAndOrdersOnChart,
		settings_showLiquidationPriceOnChart: settings.showLiquidationPriceOnChart,
		settings_showMarketBar: settings.showMarketBar,
		settings_showElfaWidget: settings.showElfaWidget,
		settings_showOrderbook: settings.showOrderbook,
		settings_showBuysAndSellsOnChart: settings.showBuysAndSellsOnChart,
		settings_showOrderbookOnMobileTradeView:
			settings.showOrderbookOnMobileTradeView,
		settings_cancelExistingOrdersOnClosePosition:
			settings.cancelExistingOrdersOnClosePosition,

		// Trading preferences
		settings_slippageTolerance: settings.slippageTolerance,
		settings_priorityFee: settings.priorityFee,
		settings_customPriorityFee: settings.customPriorityFee,
		settings_maxPriorityFeeCap: settings.maxPriorityFeeCap,
		settings_auctionDuration: settings.auctionDuration,

		// Subscription types
		settings_accountSubscriberType: settings.accountSubscriberType,
		settings_globalEventsSubscriptionType:
			settings.globalEventsSubscriptionType,
		settings_selfEventsSubscriptionType: settings.selfEventsSubscriptionType,

		// General preferences
		settings_explorer: settings.explorer,
		settings_theme: settings.theme,
		settings_traderProfile: settings.traderProfile,
		settings_swapClientType: settings.swapClientType,
	};
}
